/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-case-declarations */
import { Row } from 'common/types/scalarSpreadsheet';
import { alphabetGenerator } from 'utilities/alphabet-utilities';
import { ConvertibleNotesLedgerCell, ConvertibleNotesLedgerTotalParserProps } from '../types';
import * as c from './constants';

const totalParser = ({ columns, rows }: ConvertibleNotesLedgerTotalParserProps) => {
  const oneDecimalCells = [c.INTEREST_RATE_ROW, c.COMPOUNDING_PERIODS_PER_YEAR_ROW, c.CONVERSION_DISCOUNT_ROW];
  let totalsRow: Row<ConvertibleNotesLedgerCell>[] = [];
  const totalColumns = columns.length;
  const alphabet = alphabetGenerator([], totalColumns);
  const sumExpr = (rowIndex: number) => columns.map((col, colIndex) => `${  alphabet[colIndex]  }${rowIndex}`).join(',');

  rows.forEach(({ alias, format, valueViewer, hasTotal, ...rest }: Row<ConvertibleNotesLedgerCell> & { hasTotal?: boolean }, rowIndex: number) => {
    if (rowIndex === rows.length -1) {
      return; // Skip the last row
    }
    const columnLegend = alphabet[0];
    const rowIndexAux = rowIndex + 1;
    const key = columnLegend + rowIndexAux;
    const baseExpr = `=sum(${sumExpr(rowIndexAux)})`;
    const totalExpr = rowIndexAux === c.CONVERSION_PRICE_PER_SHARE_ROW ? `${baseExpr}/${totalColumns}` : baseExpr;

    const colFormat = format?.style;
    const gridFormat = colFormat && 'number';

    const fractionDigits = oneDecimalCells.includes(rowIndexAux) ? 1 : 0;


    const cell = {
      hidden: !hasTotal,
      readOnly: true,
      alias,
      valueViewer: hasTotal ? valueViewer : undefined,
      dataSourceKey: '',
      key,
      gridType: gridFormat,
      className: rest.className,
      format: {
        style: colFormat,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
      },
      expr: hasTotal && totalExpr,
    } as unknown as ConvertibleNotesLedgerCell;

    totalsRow = {
      ...totalsRow,
      [key]: cell,
    };
  });
  return totalsRow;
};

export default totalParser;
